import { Component, OnInit } from '@angular/core';
import { ERROR_TEMPLATE_ENUM } from '../enums/new-error-messages-enum';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { NewServiceErrorEnum } from '../enums/new-service-error.enum';
import { RedirectService } from '../shared/redirect.service';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';


@Component({
    selector: 'app-bdb-error',
    templateUrl: './bdb-error.component.html',
    styleUrls: ['./bdb-error.component.sass']
})
export class BdbErrorComponent implements OnInit {
    title: string;
    subtitle: SafeHtml;
    errorCode: string;
    buttonText: string;
    imgClass: string;
    currentErrorIndex: number;
    currentSite = '';

    dailyBlockageErrorCodes = [
        NewServiceErrorEnum.DEBIT_CARD_BLOCKED_BY_SECURITY_DAYS,
        NewServiceErrorEnum.BLOCKED_SEC_PASS,
        NewServiceErrorEnum.CONFRONTA_WRONG_ANSWERS,
        NewServiceErrorEnum.SECURE_PASSWORD_BLOCKED_OTHER_MEDIUM,
        NewServiceErrorEnum.DEBIT_CARD_BLOCKED_OTHER_MEDIUM,
        NewServiceErrorEnum.BLOCKED_SECURE_KEY
    ];

    serviceFailureErrorCodes = [
        NewServiceErrorEnum.CHECKPIN_SERVICE_FAILURE,
        NewServiceErrorEnum.BLOCKING_BY_ASSESSOR_CERTIFICATE
    ];

    singleSessionErrorCodes = [
        NewServiceErrorEnum.SINGLE_SESSION_BLOCKED
    ]

    conectionErrorCodes = [
        NewServiceErrorEnum.CONNECTION_ERROR
    ]

    constructor(
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly domSanitizer: DomSanitizer,
        private readonly redirectService: RedirectService,
    ) {
    }

    ngOnInit(): void {
        this.currentSite = this.bdbSessionStrgService.get(SessionStorageKeysEnum.SITE);
        this.errorCode = this.bdbSessionStrgService.get(SessionStorageKeysEnum.ERROR_CODE);
        if (this.isDailyBlockError()) {
            this.setErrorDataAndStatus(ERROR_TEMPLATE_ENUM.CHECKPIN_DEBITCARD_BLOCKED);
        } else if (this.isServiceFailureError()) {
            this.setErrorDataAndStatus(ERROR_TEMPLATE_ENUM.GENERAL_SERVICE_FAILURE);
        } else if (this.isSingleSessionError()) {
            this.setErrorDataAndStatus(ERROR_TEMPLATE_ENUM.SINGLE_SESSION_BLOCKED);
        } else if (this.isConnectionError()) {
            this.setErrorDataAndStatus(ERROR_TEMPLATE_ENUM.CONNECTION_ERROR);
        }else{
            this.setErrorDataAndStatus(ERROR_TEMPLATE_ENUM.GENERAL_SERVICE_FAILURE);
        }
    }

    private setErrorDataAndStatus(errorIndex: number): void {
        this.currentErrorIndex = errorIndex;
        this.title = ERROR_TEMPLATE_ENUM.get[errorIndex].title;
        this.subtitle = this.domSanitizer.bypassSecurityTrustHtml(ERROR_TEMPLATE_ENUM.get[errorIndex].subtitle);
        this.buttonText = ERROR_TEMPLATE_ENUM.get[errorIndex].buttonText;
        this.imgClass = ERROR_TEMPLATE_ENUM.get[errorIndex].imgClass;
        this.clearSessionStorageInformation();
    }

    private isDailyBlockError(): boolean {
        return this.dailyBlockageErrorCodes.find(item => item.toString() === this.errorCode) !== undefined;
    }

    private isServiceFailureError(): boolean {
        return this.serviceFailureErrorCodes.find(item => item.toString() === this.errorCode) !== undefined;
    }

    private isSingleSessionError(): boolean {
        return this.singleSessionErrorCodes.find(item => item.toString() === this.errorCode) !== undefined;
    }

    private isConnectionError(): boolean {
        return this.conectionErrorCodes.find(item => item.toString() === this.errorCode) !== undefined;
    }

    private clearUserInformation(): void {
        this.bdbSessionStrgService.delete(SessionStorageKeysEnum.IDENTITY_NUMBER);
    }

    private clearIdentityNumberPageVariables(): void {
        this.bdbSessionStrgService.delete('showClientTypeOptions');
        this.bdbSessionStrgService.delete('isClient');
        this.bdbSessionStrgService.delete('clientAuthenticationMethod');
        this.bdbSessionStrgService.delete('identifyTypeAuthentication');
    }

    private clearSessionStorageInformation(): void {
        this.clearUserInformation();
        this.clearIdentityNumberPageVariables();
    }

    public redirectFromError(): void {
        const errorsThatShouldRedirectToIdentityNumber: number[] = [
            ERROR_TEMPLATE_ENUM.CHECKPIN_DEBITCARD_BLOCKED,
            ERROR_TEMPLATE_ENUM.GENERAL_SERVICE_FAILURE,
            ERROR_TEMPLATE_ENUM.SINGLE_SESSION_BLOCKED
        ];
        if (errorsThatShouldRedirectToIdentityNumber.includes(this.currentErrorIndex)) {
            this.redirectService.redirectToIdentityNumber();
        } else if (ERROR_TEMPLATE_ENUM.CONNECTION_ERROR === this.currentErrorIndex) {
            this.redirectService.quit();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-error/bdb-error.component.ts